import React, { useState, useEffect } from 'react';
import { Package, ShoppingBag, Euro, Building2 } from 'lucide-react';
import { api } from '../../lib/api';

export default function AdminDashboard({ onNavigate }) {
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [franchises, setFranchises] = useState([]);

  useEffect(() => {
    api.getProducts(true).then(setProducts).catch(() => {});
    api.getOrders().then(setOrders).catch(() => {});
    api.getFranchisesFresh().then(setFranchises).catch(() => {});
  }, []);

  const revenue = orders.filter((o) => o.status !== 'cancelado').reduce((s, o) => s + o.total, 0);

  const stats = [
    { icon: Package, label: 'Productos activos', value: products.filter((p) => p.active).length, section: 'productos' },
    { icon: ShoppingBag, label: 'Pedidos', value: orders.length, section: 'pedidos' },
    { icon: Euro, label: 'Ingresos', value: `${revenue.toFixed(2).replace('.', ',')} €`, section: 'pedidos' },
    { icon: Building2, label: 'Franquicias activas', value: franchises.filter((f) => f.active && f.type === 'franquicia').length, section: 'franquicias' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-2xl font-black text-stone-800 mb-1">Escritorio</h1>
      <p className="text-sm text-stone-500 mb-8">Resumen operativo de la tienda.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        {stats.map(({ icon: Icon, label, value, section }, i) => (
          <button key={i} onClick={() => onNavigate(section)} className="bg-white rounded-lg border border-stone-200 p-5 text-left hover:shadow-md transition-shadow" data-testid={`stat-${i}`}>
            <Icon className="w-6 h-6 text-amber-500 mb-3" />
            <p className="text-2xl font-black text-stone-800">{value}</p>
            <p className="text-sm text-stone-500">{label}</p>
          </button>
        ))}
      </div>

      <h2 className="font-black text-stone-800 mb-4">Últimos pedidos</h2>
      <div className="bg-white rounded-lg border border-stone-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-stone-500 text-left">
            <tr>
              <th className="px-4 py-3 font-medium">Pedido</th>
              <th className="px-4 py-3 font-medium">Cliente</th>
              <th className="px-4 py-3 font-medium">Estado</th>
              <th className="px-4 py-3 font-medium text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {orders.slice(0, 5).map((o) => (
              <tr key={o.id} className="border-t border-stone-100">
                <td className="px-4 py-3 font-bold text-stone-800">{o.id}</td>
                <td className="px-4 py-3 text-stone-600">{o.customer.name}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-bold px-2 py-1 rounded ${o.status === 'pagado' ? 'bg-teal-100 text-teal-700' : o.status === 'completado' ? 'bg-sky-100 text-sky-700' : 'bg-stone-100 text-stone-600'}`}>{o.status}</span>
                </td>
                <td className="px-4 py-3 text-right font-bold text-stone-800">{o.total.toFixed(2).replace('.', ',')} €</td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan="4" className="px-4 py-8 text-center text-stone-400">No hay pedidos todavía.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
